import maintainRequest from "@/maintain/utils/maintainRequest";

const obj = {
  maintainGetCarportById(params) {
    return maintainRequest.get(
      `/device/maintenanceMan/carport/getCarportById`,
      {
        params,
      }
    );
  },
  maintainSearchCarportByName(params) {
    return maintainRequest.get(
      `/device/maintenanceMan/carport/searchCarportByName`,
      {
        params,
      }
    );
  },
  maintainGetAllCarport() {
    return maintainRequest.get(`/device/maintenanceMan/carport/getAllCarport`);
  },
  maintainEditCarport(data) {
    return maintainRequest.post(
      `/device/maintenanceMan/carport/editCarport`,
      data
    );
  },
  maintainAddCarTypeOfCarport(data) {
    return maintainRequest.post(
      `/device/maintenanceMan/carTypeOfCarport/addCarTypeOfCarport`,
      data
    );
  },
};
export default obj;
